import React from 'react';
import './form-label.styles.scss';

export interface IEIQFormLabelProps {
  title: string;
  description?: string | null;
}

export const EIQFormLabel = ({ title, description }: IEIQFormLabelProps) => {
  return (
    <div className="eiq-form-label">
      <span className="title">{title}</span>
      {description && <span className="description">{description}</span>}
    </div>
  );
};
